var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.94531C15 13.3893 8 18.0563 8 18.0563C8 18.0563 1 13.3893 1 7.94531C1 7.02606 1.18106 6.11581 1.53284 5.26653C1.88463 4.41725 2.40024 3.64558 3.05025 2.99556C3.70026 2.34555 4.47194 1.82994 5.32122 1.47816C6.1705 1.12637 7.08075 0.945313 8 0.945312C8.91925 0.945312 9.82951 1.12637 10.6788 1.47816C11.5281 1.82994 12.2997 2.34555 12.9497 2.99556C13.5998 3.64558 14.1154 4.41725 14.4672 5.26653C14.8189 6.11581 15 7.02606 15 7.94531V7.94531Z",
    stroke: "#38D982",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.1133C9.65685 11.1133 11 9.77014 11 8.11328C11 6.45643 9.65685 5.11328 8 5.11328C6.34315 5.11328 5 6.45643 5 8.11328C5 9.77014 6.34315 11.1133 8 11.1133Z",
    stroke: "#38D982",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.35ab73862b2ed7880645fad5fa2c3675.svg";
export { ForwardRef as ReactComponent };